/**
 * Playback timing matches the engine at 4ff8c09 in both the studio and chat.
 * Keep the chat-specific effects optimizations independent of timing: hiding
 * meters should not change the scheduling window or device buffer target.
 */
export const isChatPlayer = () => typeof window !== 'undefined' && Boolean(window.__COOKUP_CHAT_PLAYER__);

/** Audio and drum clips queued ahead of the audio clock. */
export const scheduleLookaheadSeconds = () => 0.25;

/** Instrument notes queued ahead of the audio clock. */
export const instrumentLookaheadSeconds = () => 0.12;

/** The original AudioContext target uses the user's buffer at a 48 kHz reference rate. */
export const contextLatencyHint = (bufferFrames) => bufferFrames / 48000;

/**
 * Whether level meters are worth running. The chat panel shows none, so the
 * analysers stay out of the signal path and processors send no meter reports.
 */
export const metersEnabled = () => !isChatPlayer();
